// 서버가 내려주는 이미지 경로를 API 서버 주소 기준의 절대 URL 로 변환한다.
// (예: "/data/member/x.jpg" → "https://djmin.eemo.co.kr/data/member/x.jpg")
import { API_BASE_URL } from "@/lib/api";

const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "").replace(/\/+$/, "");

export function mediaUrl(path?: string | null): string {
  const value = String(path ?? "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("//")) return `https:${value}`;
  if (value.startsWith("data:") || value.startsWith("blob:")) return value;
  return `${API_ORIGIN}/${value.replace(/^\/+/, "")}`;
}